










import AppNav from './app-nav.vue';
import Vue from 'vue';

export default Vue.extend({
  name: 'App',
  components: { AppNav },
});
